import i18n from "@/localization/i18n";
import { getAppInstance } from "@/pages/appInstance.ts";
import axios from "axios";
import locales from '@/localization/locales/locales.json'

export { onHydrationEnd }

import type { OnHydrationEndAsync } from 'vike/types'

const onHydrationEnd: OnHydrationEndAsync = async (
    pageContext
): ReturnType<OnHydrationEndAsync> => {
    // Add the google analytics' logic here as well
    // in order to record the first loaded page as a page visit as well

    // console.log('+onHydrationEnd: pageContext.is_pos_authenticated', pageContext.is_pos_authenticated)

    const app = getAppInstance()

    if (app) {
        // const gtag = app.config.globalProperties.$gtag;
        // if (gtag) {
        //     gtag.pageview({
        //         page_path: pageContext.urlPathname,
        //         page_title: document.title,
        //     });
        // } else {
        //     console.warn('Google Analytics plugin not found.');
        // }

        // @ts-ignore
        if (window.dataLayer) {
            // @ts-ignore
            window.dataLayer.push({
                event: "page_view",
                page_path: pageContext.urlPathname,
                page_title: document.title,
            });

            // @ts-ignore
            window.dataLayer.push({
                event: 'PageView',
                page_path: pageContext.urlPathname,
                page_title: document.title,
            })
        } else {
            console.warn("GTM not initialized.");
        }

        const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL
        const config = {
            headers: {
                'Cache-Control': 'no-store',
            },
        }
        const useI18nInstance = i18n.global

        axios.get(VITE_ASSET_URL + 'assets/locales/locales.json', config)
            .then((response) => {
                const localeData = response.data;

                // Check if the specific key exists and modify only its value
                if (localeData.g_txt_sav_email) {
                    localeData.g_txt_sav_email = localeData.g_txt_sav_email.replace(/@/g, "{'@'}");
                }

                if (localeData.w_txt_footer_contact_social_links_yt_url) {
                    localeData.w_txt_footer_contact_social_links_yt_url = localeData.w_txt_footer_contact_social_links_yt_url.replace(/@/g, "{'@'}");
                }

                if (localeData.w_txt_footer_media_link_youtube) {
                    localeData.w_txt_footer_media_link_youtube = localeData.w_txt_footer_media_link_youtube.replace(/@/g, "{'@'}");
                }

                if (localeData.g_txt_proposalitem_nature_legend) {
                    localeData.g_txt_proposalitem_nature_legend = localeData.g_txt_proposalitem_nature_legend
                        .replace(/@/g, "{'@'}")
                        .replace(/\|/g, "{'|'}");
                }

                useI18nInstance.setLocaleMessage('fr', response.data)
            })
            .catch((error) => {
                const localeData = locales.fr

                // Check if the specific key exists and modify only its value
                if (localeData.g_txt_sav_email) {
                    localeData.g_txt_sav_email = localeData.g_txt_sav_email.replace(/@/g, "{'@'}");
                }

                if (localeData.w_txt_footer_contact_social_links_yt_url) {
                    localeData.w_txt_footer_contact_social_links_yt_url = localeData.w_txt_footer_contact_social_links_yt_url.replace(/@/g, "{'@'}");
                }

                if (localeData.w_txt_footer_media_link_youtube) {
                    localeData.w_txt_footer_media_link_youtube = localeData.w_txt_footer_media_link_youtube.replace(/@/g, "{'@'}");
                }

                if (localeData.g_txt_proposalitem_nature_legend) {
                    localeData.g_txt_proposalitem_nature_legend = localeData.g_txt_proposalitem_nature_legend
                        .replace(/@/g, "{'@'}")
                        .replace(/\|/g, "{'|'}");
                }

                useI18nInstance.setLocaleMessage('fr', localeData)
                console.log('Error fetching locale.json from minio:', error);
                console.log('Falling back to local locales.json...')
            })
    }
}